/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';

import Header from '../parts/Header';
import Footer from '../parts/Footer';
import blogData from '../json/blogData';
import blogDataEn from '../json/blogDataEn';
import AnimatedContent from '../components/AnimatedContent';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function BlogDetailPage() {
  const { t, language } = useLanguage();
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Select blog data based on current language
  const currentBlogData = language === 'en' ? blogDataEn : blogData;
  const blog = currentBlogData.find((item) => item.id === parseInt(id, 10));

  // Scroll to top when component mounts or id changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!blog) {
    return (
      <>
        <Header />
        <main className="bg-gray-50 min-h-screen py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">
              {t('articleNotFound')}
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              {t('articleNotFoundDesc')}
            </p>
            <Link 
              to="/blog"
              className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors"
            >
              {t('backToBlog')}
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  // Get related articles (excluding current article)
  const relatedArticles = currentBlogData
    .filter((item) => item.id !== blog.id && item.category === blog.category)
    .slice(0, 3);

  return (
    <>
      <Header />
      
      <main 
        className="min-h-screen" 
      >
        {/* Unified Article Section */}
        <section className="py-8">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              {/* Article Header */}
              <Fade direction="up" duration={1000}>
                <div className="mb-8">
                  <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {blog.category}
                  </span>
                </div>
                
                <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                  {blog.title}
                </h1>
                
                <div className="flex flex-wrap items-center gap-6 text-white mb-8">
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                    <span>Oleh {blog.author}</span>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>
                      {new Date(blog.publishedDate).toLocaleDateString('id-ID', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </span>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.readTime} baca</span>
                  </div>
                </div>
              </Fade>

              {/* Featured Image */}
              <Fade direction="up" duration={1000} delay={200}>
                <div className="mb-12">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-100 lg:h-96 object-cover rounded-xl"
                    onError={(e) => {
                      e.target.src = '/assets/images/Surtido.png';
                    }}
                  />
                </div>
              </Fade>

              {/* Main Content */}
              <div className="mb-12">
                <AnimatedContent content={blog.content} />
              </div>

              {/* Tags */}
              <Fade direction="right" duration={1200} delay={500}>
                <div className="mb-8 pt-8 border-t border-gray-200">
                  <h3 className="text-lg font-semibold text-white mb-4">Tags:</h3>
                  <div className="flex flex-wrap gap-2">
                    {blog.tags.map((tag) => (
                      <span 
                        key={tag}
                        className="bg-green-900 text-white px-3 py-1 rounded-full text-sm font-medium hover:bg-green-200 hover:text-green-900 transition-colors cursor-pointer"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Fade>

              {/* Related Articles */}
              {relatedArticles.length > 0 && (
                <div className="mb-16">
                  <Fade direction="up" duration={1000}>
                    <div className="text-center mb-12">
                      <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
                        Produk Pupuk Terkait
                      </h2>
                      <p className="text-lg text-gray-600">
                        Produk pupuk dan nutrisi lain yang mungkin Anda butuhkan
                      </p>
                    </div>
                  </Fade>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {relatedArticles.map((relatedBlog, index) => (
                      <Fade key={relatedBlog.id} direction="up" duration={1000} delay={200 + index * 100}>
                        <article className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                          <div className="relative overflow-hidden">
                            <img 
                              src={relatedBlog.image} 
                              alt={relatedBlog.title}
                              className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
                              onError={(e) => {
                                e.target.src = '/assets/images/Surtido.png';
                              }}
                            />
                            <div className="absolute top-4 left-4">
                              <span className="bg-green-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                                {relatedBlog.category}
                              </span>
                            </div>
                          </div>
                          
                          <div className="p-6">
                            <div className="flex items-center justify-between text-sm text-gray-500 mb-3">
                              <span>{relatedBlog.author}</span>
                              <span>{relatedBlog.readTime}</span>
                            </div>
                            
                            <h3 className="text-lg font-bold text-gray-800 mb-3 hover:text-green-600 transition-colors">
                              <Link 
                                to={`/blog/${relatedBlog.id}`}
                                onClick={() => {
                                  window.scrollTo(0, 0);
                                }}
                              >
                                {relatedBlog.title}
                              </Link>
                            </h3>
                            
                            <p className="text-gray-600 mb-4 line-clamp-2">
                              {relatedBlog.excerpt}
                            </p>
                            
                            <Link 
                              to={`/blog/${relatedBlog.id}`}
                              className="text-green-600 font-semibold hover:text-green-700 transition-colors"
                              onClick={() => {
                                window.scrollTo(0, 0);
                              }}
                            >
                              Baca Selengkapnya →
                            </Link>
                          </div>
                        </article>
                      </Fade>
                    ))}
                  </div>
                </div>
              )}

              {/* Navigation */}
              <Fade direction="up" duration={1000}>
                <div className="pt-8 border-t border-gray-200">
                  <div className="flex justify-between items-center">
                    <button 
                      type="button"
                      onClick={() => navigate(-1)}
                      className="flex items-center gap-2 text-white hover:text-green-700 transition-colors"
                    >
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {t('back')}
                    </button>
                  
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
